import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), null, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segments, (segment, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (segment.type === 'strong')
            ? (_openBlock(), _createElementBlock("strong", _hoisted_1, _toDisplayString(segment.text), 1))
            : (segment.type === 'em')
              ? (_openBlock(), _createElementBlock("em", _hoisted_2, _toDisplayString(segment.text), 1))
              : (segment.type === 'link')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    href: segment.href,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, _toDisplayString(segment.text), 9, _hoisted_3))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(_toDisplayString(segment.text), 1)
                  ], 64))
        ], 64))
      }), 128))
    ]),
    _: 1
  }))
}